import { computed, Directive, inject, input, InputSignal, Signal } from '@angular/core';
import { Source81 } from 'analytic-events/MI/services/BannerWidgetService/events/Source81';
import { MI_BANNER_ANALYTICS_SOURCE } from '../tokens/mi-banner-analytics-source.token';

@Directive({
  selector: '[luMiBannerAnalyticsContext]',
  providers: [
    {
      provide: MI_BANNER_ANALYTICS_SOURCE,
      useFactory: (): Signal<Source81> => inject(MiBannerAnalyticsContextDirective).analyticsSource,
    },
  ],
})
export class MiBannerAnalyticsContextDirective {
  public readonly luMiBannerAnalyticsContext: InputSignal<Source81> = input.required<Source81>();

  public readonly analyticsSource: Signal<Source81> = computed((): Source81 => this.luMiBannerAnalyticsContext());
}
